import { defineStore } from 'pinia';
import { getRoutes } from '@/router/config';
import { PermsStatusEnum } from '@tencent/iegsp-common/tools/utils/route';

import { MenuRoute, RouteType, withoutPerms } from '@tencent/iegsp-common/tools/utils/route';

interface IPerm {
  front_path: string[];
  allowed_all_front: boolean;
}

const getPermission = () => Promise.resolve({ front_path: [], allowed_all_front: false });

export const usePermissionStore = defineStore('permission', {
  state: () => ({
    // 这个变量是为了显示哪些路由需要显示在菜单，不是注册路由
    menuRoutes: [] as MenuRoute[],
    perm: { front_path: [], allowed_all_front: false } as IPerm,
    permStatus: PermsStatusEnum.unready,
  }),
  actions: {
    getPermission() {
      return getPermission()
        .then((res) => {
          this.permStatus = PermsStatusEnum.success;
          this.perm = res;
          this.menuRoutes = filterMenuRoutesWithPerms(getRoutes());
        })
        .catch((err) => {
          this.permStatus = PermsStatusEnum.fail;
          return Promise.reject(err);
        });
    },
  },
});

export const hasPermission = (route: MenuRoute, inPerm?: IPerm): boolean => {
  if (withoutPerms(route)) return true;
  if (!route.path) return true;
  let perm = inPerm;
  if (!perm) {
    const permissionStore = usePermissionStore();
    perm = permissionStore.perm;
  }
  return perm.allowed_all_front || perm.front_path?.includes(route.path);
};

export const filterMenuRoutesWithPerms = (routes: MenuRoute[]) =>
  routes
    .map((route) => ({
      ...route,
      children: route.children?.filter((i) => {
        const iType = i.meta.type as RouteType;
        return [RouteType.MENU_ALL].includes(iType) || ([RouteType.MENU].includes(iType) && hasPermission(i));
      }),
    }))
    .filter((i) => i.children?.length);
